var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-box"},[_c('span',{staticClass:"text",class:{
      'width-200': _vm.width200,
      'width-255': _vm.width255,
      'width-300': _vm.width300,
    }},[_vm._v(_vm._s(_vm.text))]),_c('svg',{class:{ bottom: _vm.bottom, batch: _vm.batch, english: _vm.$i18n.locale === 'zh' },attrs:{"width":"10","height":"10","viewBox":"-50 -50 300 300"}},[_c('polygon',{staticClass:"triangle radius",attrs:{"stroke-linejoin":"round","points":"100,0 -80,200 280,200"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }